import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const handlePartnerSetupIntentError = async ({ codeName, setupIntentId }: { codeName: string; setupIntentId: string }) => {
  const response = await mutationExecute({
    variables: {
      codeName,
      setupIntentId,
    },
    mutation: graphql(`
      mutation HandlePartnerSetupIntentError($codeName: String!, $setupIntentId: String!) {
        handlePartnerSetupIntentError(codeName: $codeName, setupIntentId: $setupIntentId)
      }
    `),
  });

  return response.data?.handlePartnerSetupIntentError ?? false;
};
